import { Order, OrderStatus } from "@/models/Order";

/** Mirrors OrderHelper.GetOpenOrders: Shipped/Canceled are finished, Error/ReturnToSender already shipped. */
export const OPEN_ORDER_STATUSES: OrderStatus[] = [
    OrderStatus.Created, OrderStatus.Processing, OrderStatus.PartialPayment,
    OrderStatus.ReadyForPickup, OrderStatus.AwaitingPriorAuthorization, OrderStatus.MissingAcceptance,
];

type OrderStatusOnly = Partial<Pick<Order, "status">>;

export function isOpenOrder(order?: OrderStatusOnly | null): boolean {
    return order?.status != null && OPEN_ORDER_STATUSES.includes(order.status);
}

export function countOpenOrders(orders?: OrderStatusOnly[] | null): number {
    return (orders ?? []).filter(isOpenOrder).length;
}
